"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookTemplateItem = exports.TemplateSelectMethods = void 0;
var React = require("react");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var TemplateDescription_1 = require("./TemplateDescription");
var TemplateThumbnailImage_1 = require("./TemplateThumbnailImage");
var TemplateSelectMethods;
(function (TemplateSelectMethods) {
    TemplateSelectMethods.Button = 'button';
    TemplateSelectMethods.Image = 'image';
})(TemplateSelectMethods = exports.TemplateSelectMethods || (exports.TemplateSelectMethods = {}));
var WorkbookTemplateItem = /** @class */ (function (_super) {
    __extends(WorkbookTemplateItem, _super);
    function WorkbookTemplateItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onTemplateSelectedViaImage = function () {
            _this.props.onTemplateSelected(_this.props.template.id, _this.props.template.connectionType.internalName, TemplateSelectMethods.Image);
        };
        return _this;
    }
    WorkbookTemplateItem.prototype.thumbnailImage = function () {
        return (React.createElement(TemplateThumbnailImage_1.TemplateThumbnailImage, { template: this.props.template, onClick: this.onTemplateSelectedViaImage, imageWidth: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.LargeThumbnailImageWidth + 'px', imageHeight: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.LargeThumbnailImageHeight + 'px' }));
    };
    WorkbookTemplateItem.prototype.render = function () {
        return (React.createElement("div", { id: "template-" + this.props.template.id, className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDiv },
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ImageDiv }, this.thumbnailImage()),
            React.createElement(TemplateDescription_1.WorkbookTemplateDescription, { template: this.props.template, onTemplateSelected: this.props.onTemplateSelected })));
    };
    return WorkbookTemplateItem;
}(React.Component));
exports.WorkbookTemplateItem = WorkbookTemplateItem;
//# sourceMappingURL=WorkbookTemplateItem.js.map